import { useActiveWeb3React } from 'hooks'
import React from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import AddLiquidity from './index'
import { WETH9 } from '@uniswap/sdk-core'

export function RedirectDuplicateTokenIds(
  props: RouteComponentProps<{ currencyIdA: string; currencyIdB: string; feeAmount?: string }>
) {
  const {
    match: {
      params: { currencyIdA, currencyIdB },
    },
  } = props

  const { chainId } = useActiveWeb3React()

  // prevent weth + eth
  const isETHOrWETHA =
    currencyIdA === 'HYPE' || (chainId !== undefined && currencyIdA === WETH9[chainId as keyof typeof WETH9]?.address)
  const isETHOrWETHB =
    currencyIdB === 'HYPE' || (chainId !== undefined && currencyIdB === WETH9[chainId as keyof typeof WETH9]?.address)

  if (
    currencyIdA &&
    currencyIdB &&
    (currencyIdA.toLowerCase() === currencyIdB.toLowerCase() || (isETHOrWETHA && isETHOrWETHB))
  ) {
    return <Redirect to={`/add/${currencyIdA}`} />
  }
  return <AddLiquidity {...props} />
}
